<template>
  <v-row justify="center" v-if="!$vuetify.breakpoint.smAndDown">
    <div class="text-center" v-if="filterconsolidado.length !== 0">
      <v-menu
        v-model="menua"
        open-on-hover
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
        
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
           fab
           
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            elevation="0"
            @click="anterior !== 0 ? otroArt(anterior) : false"
            :style="anterior !== 0 ? 'cursor:pointer' : 'cursor:not-allowed'"
            :color="anterior !== 0
                ? !$vuetify.breakpoint.smAndDown
                  ? 'primary'
                  : 'accent'
                : '#BDBDBD'
            "
          >
            <v-icon dark large color="secondary" > mdi-chevron-left </v-icon>
          </v-btn>
        </template>

        <v-card
          max-width="400px"
          elevation="0"
          
       
          class="v-cardgrid rounded-md"
          v-if="anterior !== 0"
        >
          <v-list-item>
            <v-avatar class="ml-n4 my-2" size="100" tile>
              <v-img :src="imgArt(anterior)"></v-img>
            </v-avatar>

            <v-list-item-content class="pa-2">
              <v-list-item-subtitle class="body-1">
                ARTICULO ANTERIOR:
              </v-list-item-subtitle>

              <v-list-item-title class="body-1 font-weight-bold">
                {{ anterior }}
              </v-list-item-title>
              <div>{{ descripa }}</div>
            </v-list-item-content>
            
          </v-list-item>

          <v-divider></v-divider>
        </v-card>
      </v-menu>
      <v-menu
        v-model="menu"
        open-on-hover
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
        v-if="!$vuetify.breakpoint.smAndDown"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            dark
            x-small
            elevation="0"
            @click="siguiente != 0 ? otroArt(siguiente) : false"
            v-bind="attrs"
            v-on="on"
            :style="siguiente != 0 ? 'cursor:pointer' : 'cursor:not-allowed'"
            :color="
              siguiente != 0
                ? !$vuetify.breakpoint.smAndDown
                  ? 'primary'
                  : 'accent'
                : '#BDBDBD'
            "
          >
            <v-icon dark large color="secondary"> mdi-chevron-right </v-icon>
          </v-btn>
        </template>

        <v-card
          max-width="400px"
          elevation="0"
          outlined
          flat
          class="v-cardgrid rounded-md"
          v-if="siguiente != 0"
        >
          <v-list-item>
            <v-avatar class="ml-n4 my-2" size="100" tile>
              <v-img :src="imgArt(siguiente)"></v-img>
            </v-avatar>

            <v-list-item-content class="pa-2">
              <v-list-item-subtitle class="body-1"
                >ARTICULO SIGUIENTE:</v-list-item-subtitle
              >

              <v-list-item-title
                class="body-1 font-weight-bold"
              >
                {{ siguiente }}
              </v-list-item-title>
              <div>{{ descrips }}</div>
            </v-list-item-content>

            <v-list-item-action> </v-list-item-action>
          </v-list-item>

          <v-divider></v-divider>
        </v-card>
      </v-menu>
    </div>
  </v-row>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  
  export default {
    props: {
      codArt: String,
    },
    created() {
      if (this.filterconsolidado.length !== 0)  this.elementosCat();
    },
    methods: {
      ...mapMutations(["CLR_DATOS_ART"]),
      ...mapActions(["cargarDatosPromo", "cargarFeature", "cargarDatosArt"]),
      otroArt(codart) {
     
        window.scrollTo(0, 0);
        //this.CLR_PROMO();
        let xCodart = encodeURIComponent(codart);
        this.$router.push({ path: `/detalle/${xCodart}` }).catch((err) => {});
        this.cargarDatosPromo({ codart: codart });
        this.cargarDatosArt({ codart: codart });

        this.cargarFeature({
          articulo: codart,
          cia: 1,
          opc: 8,
        });
        this.CLR_DATOS_ART();
      },
      elementosCat() {
        let xDatos = [];
        
        this.filterconsolidado.forEach((x) => {
          xDatos.push({ cod: x.Codigo, img: x.Imagen, nb: x.Nombre });
        });
        
        const index = xDatos.findIndex((item) => item.cod === this.codArt);

        if(xDatos[index]!==undefined){
          this.actual = xDatos[index].cod;

          index < xDatos.length - 1
            ? (this.siguiente = xDatos[index + 1].cod)
            : (this.siguiente = 0);
          index == 0
            ? (this.anterior = 0)
            : (this.anterior = xDatos[index - 1].cod);

          this.siguiente != 0
            ? (this.descrips = xDatos[index + 1].nb)
            : (this.descrips = 0);
          index == 0 ? (this.descripa = 0) : (this.descripa = xDatos[index - 1].nb);
        }
      
        return xDatos;
      },
      ChrEsp(chr) {
        const chrSplit = chr.split("")
        let newChr = ""

        chrSplit.forEach(x => {
          if (x === "/") newChr += "-"
          else if (x === ".") newChr += "-"
          else newChr += x
        })

        return newChr
      },
      imgArt(id) {
        let urlImg = "";

        urlImg = this.domoapi2_img
        urlImg += "Articulo/"
        urlImg += this.ChrEsp(id)
        urlImg += "/Principal?Cia=15&"
        urlImg += "i=" + this.updateImg

        return urlImg;
      },
    },
    computed: {
      ...mapState(["domoapi2_img"]),
      ...mapGetters(["filterconsolidado"]),
    },
    data() {
      return {
        descrips: "",
        descripa: "",
        menu: false,
        menua: false,
        anterior: 0,
        siguiente: 0,
        actual: 0,
        updateImg: Math.floor(Math.random() * 100)
      };
    },
  };
</script>

<style scoped>
.v-cardgrid {
  background-color: #ffffff !important;

  border: 0px solid #B05954 !important;

  transition: opacity 0.4s ease-in-out;
  margin: 0.5px;
}
</style>
